import React from 'react';
import { connect } from 'react-redux';

import Icon from './../Icon';
import Dropdown from './../Dropdown';
import Select from './../Select';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'country';

const CountryDropdown = props => {
    const { value, save } = props;
    const text = value || 'Select';
    return (
        <div>
            Country registration:
            <Dropdown buttonClassName="lnk-dropdown" text={text}>
                <Select value={value} onChange={save} className="menu menu-selectable menu-selectable-overflow">
                    {countryList.map(country =>
                        <li key={country} value={country} className="menu-item">
                            {country}
                            <Icon className="svg-icon" iconName="check-empty" />
                        </li>
                    )}
                </Select>
            </Dropdown>
        </div>
    );
}

const mapStateToProps = state => ({
    value: state.user[fieldName]
});
const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CountryDropdown);

const countryList = `Andorra
United Arab Emirates
Afghanistan
Antigua
Anguilla
Albania
Armenia
Netherlands Antilles
Angola
Argentina
American Samoa
Austria
Australia
Aruba
Aland Islands
Azerbaijan
Bosnia
Barbados
Bangladesh
Belgium
Burkina Faso
Bulgaria
Bahrain
Burundi
Benin
Bermuda
Brunei
Bolivia
Brazil
Bahamas
Bhutan
Bouvet Island
Botswana
Belarus
Belize
Canada
Cocos Islands
Congo
Central African Republic
Congo Brazzaville
Switzerland
Cote Divoire
Cook Islands
Chile
Cameroon
China
Colombia
Costa Rica
Serbia
Cuba
Cape Verde
Christmas Island
Cyprus
Czech Republic
Germany
Djibouti
Denmark
Dominica
Dominican Republic
Algeria
Ecuador
Estonia
Egypt
Western Sahara
Eritrea
Spain
Ethiopia
European Union
Finland
Fiji
Falkland Islands
Micronesia
Faroe Islands
France
Gabon
England
Grenada
Georgia
French Guiana
Ghana
Gibraltar
Greenland
Gambia
Guinea
Guadeloupe
Equatorial Guinea
Greece
Sandwich Islands
Guatemala
Guam
Guinea-Bissau
Guyana
Hong Kong
Heard Island
Honduras
Croatia
Haiti
Hungary
Indonesia
Ireland
Israel
India
Indian Ocean Territory
Iraq
Iran
Iceland
Italy
Jamaica
Jordan
Japan
Kenya
Kyrgyzstan
Cambodia
Kiribati
Comoros
Saint Kitts and Nevis
North Korea
South Korea
Kuwait
Cayman Islands
Kazakhstan
Laos
Lebanon
Saint Lucia
Liechtenstein
Sri Lanka
Liberia
Lesotho
Lithuania
Luxembourg
Latvia
Libya
Morocco
Monaco
Moldova
Montenegro
Madagascar
Marshall Islands
MacEdonia
Mali
Burma
Mongolia
MacAu
Northern Mariana Islands
Martinique
Mauritania
Montserrat
Malta
Mauritius
Maldives
Malawi
Mexico
Malaysia
Mozambique
Namibia
New Caledonia
Niger
Norfolk Island
Nigeria
Nicaragua
Netherlands
Norway
Nepal
Nauru
Niue
New Zealand
Oman
Panama
Peru
French Polynesia
New Guinea
Philippines
Pakistan
Poland
Saint Pierre
Pitcairn Islands
Puerto Rico
Palestine
Portugal
Palau
Paraguay
Qatar
Reunion
Romania
Serbia
Russia
Rwanda
Saudi Arabia
Solomon Islands
Seychelles
Sudan
Sweden
Singapore
Saint Helena
Slovenia
Svalbard, I Flag Jan Mayen
Slovakia
Sierra Leone
San Marino
Senegal
Somalia
Suriname
Sao Tome
El Salvador
Syria
Swaziland
Caicos Islands
Chad
French Territories
Togo
Thailand
Tajikistan
Tokelau
Timorleste
Turkmenistan
Tunisia
Tonga
Turkey
Trinidad
Tuvalu
Taiwan
Tanzania
Ukraine
Uganda
Us Minor Islands
United States
Uruguay
Uzbekistan
Vatican City
Saint Vincent
Venezuela
British Virgin Islands
Us Virgin Islands
Vietnam
Vanuatu
Wallis and Futuna
Samoa
Yemen
Mayotte
South Africa
Zambia
Zimbabwe`.split('\n');


// WEBPACK FOOTER //
// ./src/components/profile/CountryDropdown.js